import { UserCompanies } from "../app/models/User";
import * as lc from "../app/modules/localstorage"
import { createRef } from "../db";

export const getAccessibleCompany = () => {
    
  //Create Ref Data Company
  const companyAccesses: UserCompanies[] = lc.getItemLC(lc.LCName.CompanyList)
  return companyAccesses    

}

export const getAccessibleCompanyRef = () => {
    return getAccessibleCompany().map((company: UserCompanies) => (createRef("company", company.id)))
}

  